export function convertUnixTimeToDate(unixTime) {
    var a = new Date(unixTime * 1000);
    var months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ];
    var dayInWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    var day = dayInWeek[a.getDay()];
    return day + ', ' + month + ' ' + date;
}

export function convertUnixTimeToTime(unixTime) {
    return moment(unixTime * 1000).format('hh:mm A');
}

export function getCustomMonth(unixTime) {
    var months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];

    return months[new Date(unixTime).getMonth()];
}

export function orderSchedulesInWeek(schedules) {
    let schedule = {};

    for (const i of schedules) {
        const day = convertUnixTimeToDate(i.start).split(',')[0];
        schedule[day] = [];
    }

    for (const i of schedules) {
        const day = convertUnixTimeToDate(i.start).split(',')[0];
        schedule[day] = [
            ...schedule[day],
            {
                time: convertUnixTimeToTime(i.start),
                start: i.start,
                end: i.end,
            },
        ];
    }
    return schedule;
}

export function getCurrentDay() {
    return moment().unix();
}

export function addDays(x, y) {
    return moment(moment.unix(x)).add(y, 'days').unix();
}

export function convertUnixTimeToObjectDate(unixTime) {
    var a = new Date(unixTime * 1000);
    var months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ];
    var dayInWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    var day = dayInWeek[a.getDay()];
    return {
        day: day,
        month: month,
        date: date,
        year: year,
    };
}

export function CompareObjectDate(objectDateA, ObjectDateB) {
    if (objectDateA.date === ObjectDateB.date && objectDateA.month === ObjectDateB.month && objectDateA.year === ObjectDateB.year) {
        return true;
    }
    return false;
}

export function convertMonthFormat(month, format) {
    let months = {
        'Jan': 'January',
        'Feb': 'February',
        'Mar': 'March',
        'Apr': 'April',
        'May': 'May',
        'Jun': 'June',
        'Jul': 'July',
        'Aug': 'August',
        'Sep': 'September',
        'Oct': 'October',
        'Nov': 'November',
        'Dec': 'December'
    };

    if (format === 'long') {
        return months[month];
    }
    return Object.keys(months).find(key => months[key] === month);
}

export function checkLeapYear(year) {
    return moment([year]).isLeapYear();
}